import React from 'react';
import { FieldPrecision } from '../../services/analyticsService';

interface Props {
  fields: FieldPrecision[];
}

export const FieldsTable: React.FC<Props> = ({ fields }) => {
  const sortedFields = [...fields].sort((a, b) => a.precision - b.precision);

  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Precision par champ</h3>
      <div className="space-y-3">
        {sortedFields.map((field) => (
          <div key={field.field_path} className="flex items-center gap-3">
            <div className="w-40 text-sm font-mono truncate" title={field.field_path}>
              {field.field_path}
            </div>
            <div className="flex-1">
              <div className="h-4 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full ${
                    field.precision > 0.9 ? 'bg-green-500' :
                    field.precision > 0.7 ? 'bg-yellow-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${field.precision * 100}%` }}
                />
              </div>
            </div>
            <div className="w-16 text-right text-sm font-medium">
              {(field.precision * 100).toFixed(0)}%
            </div>
            <div className="w-20 text-right text-xs text-gray-500">
              {field.errors} err / {field.total}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
